// import gsap from 'gsap';
import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';
import Sine from 'gsap';
import Typed from 'typed.js';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';

console.log(ScrollToPlugin);
// gsap.registerPlugin(ScrollToPlugin);

export function setInitialScrollPosition() {
	if (window.location.hash) {
		const id = window.location.hash;

		scrollToTarget(id, {
			instant: false,
		});
	}
}


/**
 *
 * @param {*} target
 * @param {*} config
 * @return Promise
 */
export function scrollToTarget(target, config = {}) {
	const {
		instant = false, // bool
		scrollWrapper = window, // element
		offset = 0, // number
		speed = 0.6,
		onComplete = undefined,
	} = config;

	const duration = instant ? 0 : speed;

	const tween = TweenMax.to(scrollWrapper, duration, {
			scrollTo: {
				y: target,
				offsetY: offset,
				autoKill: false,
			},
			onComplete: onComplete,
		},
		Sine.easeOut
	);


}

// export function initScrollingFeatures() {

// }

// export function unload_scrolling_features() {

// }



// WEBPACK FOOTER //
// ./scripts/modules/scrolling.js